<template>
  <div style="padding: 10px 14px">
    <h3>Disclaimer</h3>
    <p>
      Dear User, to use this software, please carefully read this
      <em>Disclaimer Agreement</em>
      and fully understand the content of each clause. Unless you have fully read, completely understood, and accepted all clauses of this Agreement, please do not purchase
      this service.
      <strong>
        <u>
          Your act of clicking "Agree", "Next Step", purchasing, using this service, or any other express or implied act indicating acceptance of this Agreement shall be
          deemed that you have read and agreed to be bound by this Agreement, which shall become a legally binding document for both parties.
        </u>
      </strong>
    </p>
    <p>
      1. You agree and understand that we will use commercially reasonable efforts to ensure the security of data storage for you in the services of this software; however, we
      cannot provide an absolute guarantee for this, including but not limited to the following circumstances:
    </p>
    <p>(1) We shall not be liable for the deletion or storage failure of relevant data in the services of this software;</p>
    <p>
      (2) We have the right to determine the maximum storage period of your data in this software based on actual circumstances and legal and regulatory requirements. You may
      back up relevant data by yourself within the scope of this storage space according to your own needs. However, due to factors such as limited storage space, technical
      reasons, equipment and network environment, the data in this storage space may be unable to be fully saved, lost, or have omissions, and we shall not be liable for such
      circumstances;
    </p>
    <p>
      (3) If you stop using the relevant functions and services of the software or the services are terminated or cancelled, we will delete your data from the server. Unless
      required by applicable laws and regulations, we have no obligation to return any data to you after the services are stopped, terminated, or cancelled.
    </p>
    <p>In view of the particularity of network services, we shall not be liable for the following acts taken based on business strategies and user experience:</p>
    <p>(1) You agree that we may modify, interrupt, or terminate part or all of this service at any time;</p>
    <p>
      (2) We have the right to conduct inspection, maintenance, or repair on the platform providing this service or relevant equipment regularly or irregularly. If such
      circumstances result in the interruption or suspension of this service within a reasonable time, we shall not be liable for this;
    </p>
    <p>
      (3) Due to business strategy arrangements or adjustments, the specific content of this software service available to users in different regions may vary, and the
      specific content shall be subject to what we actually provide. We shall not be liable for this.
    </p>
    <p>
      2. Since we cannot ensure the accuracy of the data contained in the data source or the continuous smoothness of the data receiving channel, we cannot guarantee the
      continuity, timeliness, or accuracy of the provision of relevant services. If you find that the data received or updated by us is inaccurate, erroneous, or incomplete,
      you shall promptly contact us or the data source where your information is located for verification.
    </p>
    <p>
      3. This software does not contain any malicious code intended to damage your computer data or obtain your private information. This software has undergone detailed
      testing, but it cannot be guaranteed to be fully compatible with all software and hardware systems, nor can it be guaranteed to be completely free of errors. In case of
      incompatibility or software errors, you may call the technical support hotline to report the situation to us for technical support. If the compatibility issue cannot be
      resolved, you may delete this software.
    </p>
    <p>
      4. To the maximum extent permitted by applicable law, we shall not be liable for any damages and risks arising from the use or inability to use this software, including
      but not limited to direct or indirect personal injury, loss of business profits, business interruption, loss of business information, or any other economic losses.
    </p>
    <p>
      5. If you violate the provisions of this Agreement and cause damages to us, we have the right to take measures including but not limited to suspending the use license,
      terminating the provision of services, restricting use, and pursuing legal liability.
    </p>
    <p>
      6. If you are complained by others or you complain about others, we have the right to provide necessary information such as the subject information, contact information
      of the relevant parties in the dispute, and the content related to the complaint to the relevant parties or authorities, so as to promptly resolve the complaint and
      dispute and protect the legitimate rights and interests of all parties.
    </p>
    <p>7. We shall not be liable for the failure to provide services normally due to the following reasons:</p>
    <p>(1) During the shutdown and maintenance period of the system that hosts this service;</p>
    <p>(2) Malfunctions of your computer, mobile phone software and hardware, communication lines, or power supply lines;</p>
    <p>(3) Improper operation by you or use of the services of this software through unauthorized or unrecognized means;</p>
    <p>(4) Risks such as failed login to this service or incomplete data synchronization caused by factors such as unstable network signals;</p>
    <p>
      (5) Reasons such as virus, Trojan horse, malicious program attack, network congestion, system instability, system or equipment failure, communication failure, power
      failure, or government actions;
    </p>
    <p>
      (6) Interruption or delay of the services of this software caused by reasons such as hacker attacks, technical adjustments or malfunctions of network providers, website
      upgrades, or system issues;
    </p>
    <p>(7) Risks such as interruption or termination of this service caused by technical adjustments of telecommunications departments;</p>
    <p>(8) Risks such as temporary shutdown of this service due to government control;</p>
    <p>Notwithstanding the provisions of the preceding paragraph, we will take reasonable actions to actively promote the restoration of normal services.</p>
    <p>8. We shall not be liable for the failure to conduct business due to software service system malfunctions caused by the following force majeure reasons:</p>
    <p>
      (1) You understand and agree that during the use of this service, you may encounter risk factors such as force majeure that affect this service. Force majeure refers to
      objective events that are unforeseeable, unavoidable, and insurmountable and cause significant impacts on one or both parties, including but not limited to natural
      disasters (such as floods, earthquakes, plague outbreaks, and storms) and social events (such as wars, riots, government actions, and epidemics). When the above
      circumstances occur, we will strive to cooperate with relevant units and make every effort to handle them promptly; however, we shall be exempted from liability within
      the scope permitted by law for any losses caused to you thereby.
    </p>
    <p>
      (2) You understand and agree that as an internet software, this software may be affected by various factors, including but not limited to user reasons, network service
      quality, and social environment; it may also be subject to various security issues, including but not limited to others' illegal use of user information to conduct
      harassment in real life, and the possibility that other software downloaded and installed by you or other websites visited by you may contain viruses, Trojan programs,
      or other malicious programs that threaten the information and data security of your terminal equipment, thereby affecting the normal use of this software. Therefore, you
      should enhance your awareness of information security and personal information protection, and pay attention to password protection to avoid losses.
    </p>
    <p>
      9. You understand and agree that during the use of this service, you may encounter risks caused by network information or other users' behaviors. We shall not be liable
      for the authenticity, applicability, or legality of any information, nor shall we be liable for damages caused to you by infringement. These risks include but are not
      limited to:
    </p>
    <p>(1) Threatening, defamatory, offensive, or illegal content from others anonymously or under a false name;</p>
    <p>(2) Any psychological or physical harm and economic loss caused or potentially caused by being misled, deceived, or other acts by others;</p>
    <p>(3) Other risks caused by network information or user behaviors.</p>
    <p>
      10. Under no circumstances should you trust information related to loans, password requests, or other property-related matters. For property-related operations, please
      be sure to verify the identity of the other party first, and always pay attention to our tips on preventing fraud crimes.
    </p>
    <p>Company: {{ activationCompany.company }}</p>
    <p>Tel: 400-632-8880</p>
    <p>Contact Person: Customer Service Specialist</p>
    <p>Address: {{ activationCompany.address }}</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Sunvol Information Technology Co., Ltd.',
        address: 'Block A, Building 11, Area C, Songshanlake International Financial Park, Dongguan City, Guangdong Province',
        abbreviation: 'Sunvol'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[1]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}

.underline {
  text-decoration: underline;
}

.primaryColor {
  color: #1e80ff;
}
</style>
